// https://vuex.vuejs.org/kr/guide/getters.html#getters
import { GetterTree } from 'vuex'
import * as types from './types'

export default <GetterTree<RootState, RootState>>{}
